import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import router from "@/router";

Vue.prototype.$operacoes_equipamentos = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      equipamentosAddEdit: "new",
      loading: false,
      text: "",
      cadastro: {
        idpdv_empty: true,
        loading: false,
        idequipamento: "",
        idponto_venda: "",
        tipo_equipamento: "",
        status: "",
        descricao: "",
        data_ativacao: "",
        numero_serie: "",
        is_app: 0,
        aplicar_taxa: 0,
        link_vendas: "",
        rede_vendas: "",
        point_sale: {},
        lojas: [],
        events: [],
        error: {
          tipo_equipamento: [],
          status: [],
          descricao: [],
          data_ativacao: [],
          numero_serie: [],
          link_vendas: [],
          rede_vendas: [],
          point_sale: [],
          lojas: [],
          events: [],
        },
      },
      filter: {
        tipo_equipamento: "",
        serie_equipamento: "",
        status: "",
        descricao: "",
      },
      equipamentos: [],
    };
  },
  methods: {
    /**
     * @description Método para listar equipamentos
     */
    getEquipamentos() {
      this.loading = true;
      this.$axios
        .post(this.ENDPOINTS.LISTAR_EQUIPAMENTOS)
        .then(response => {
          this.equipamentos = response;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * @description Método para cadastrar equipamento
     */
    async cadastrarEquipamento() {
      this.cadastro.loading = true;
      let dados = {};

      const eventByStore = this.cadastro.events.reduce((acc, event) => {
        const { sequenciador_loja } = event;
        if (!acc[sequenciador_loja]) {
          acc[sequenciador_loja] = [];
        }
        acc[sequenciador_loja].push(event.idproduto);
        return acc;
      }, {});

      if (typeof this.cadastro.lojas !== "number") {
        this.cadastro.lojas.forEach(loja => {
          if (!eventByStore[loja]) {
            eventByStore[loja] = [];
          }
        });
      } else {
        if (!eventByStore[this.cadastro.lojas]) {
          eventByStore[this.cadastro.lojas] = [];
        }
      }

      if (this.cadastro.tipo_equipamento == "POS") {
        dados = {
          tipo: this.cadastro.tipo_equipamento,
          status: this.cadastro.status,
          descricao: this.cadastro.descricao,
          dthr_ativacao: this.cadastro.data_ativacao
            ? this.cadastro.data_ativacao.length <= 10
              ? this.$config.convertDataEN(this.cadastro.data_ativacao) +
                " 00:00"
              : this.$config.convertDataEN(
                  this.cadastro.data_ativacao.split(" ")[0]
                ) +
                " 00:00 " +
                this.cadastro.data_ativacao.split(" ")[1]
            : " 00:00",
          numero_serie: this.cadastro.numero_serie,
          aplicar_comissao_ou_taxa: this.cadastro.aplicar_taxa,
          ponto_venda: {
            id: this.cadastro.point_sale.idponto_venda,
            rede_vendas: this.cadastro.rede_vendas,
          },
          produtos_sync: eventByStore,
        };
      } else {
        dados = {
          tipo: this.cadastro.tipo_equipamento,
          status: this.cadastro.status,
          descricao: this.cadastro.descricao,
          is_app: this.cadastro.is_app,
          link_vendas: this.cadastro.link_vendas,
        };
      }

      this.$axios
        .post(this.ENDPOINTS.CADASTRAR_EQUIPAMENTO, dados)
        .then(response => {
          if (response) {
            this.limparFormularioEquipamento();
            router.push({
              name: "equipments",
            });
          }
          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description Método para alterar equipamento
     */
    alterarEquipamento() {
      this.cadastro.loading = true;
      let dados = {};

      const eventByStore =
        this.cadastro.events &&
        this.cadastro.events.reduce((acc, event) => {
          const { sequenciador_loja } = event;
          if (!acc[sequenciador_loja]) {
            acc[sequenciador_loja] = [];
          }
          acc[sequenciador_loja].push(event.idproduto);
          return acc;
        }, {});

      if (typeof this.cadastro.lojas !== "number") {
        this.cadastro.lojas.forEach(loja => {
          if (!eventByStore[loja]) {
            eventByStore[loja] = [];
          }
        });
      } else {
        if (!eventByStore[this.cadastro.lojas]) {
          eventByStore[this.cadastro.lojas] = [];
        }
      }

      if (this.cadastro.tipo_equipamento == "POS") {
        dados = {
          tipo: this.cadastro.tipo_equipamento,
          status: this.cadastro.status,
          descricao: this.cadastro.descricao,
          data_ativacao: this.cadastro.data_ativacao,
          numero_serie: this.cadastro.numero_serie,
          aplicar_comissao_ou_taxa: this.cadastro.aplicar_taxa,
          ponto_venda: {
            id: this.cadastro.point_sale.idponto_venda,
            rede_vendas: this.cadastro.rede_vendas,
          },
          produtos_sync: eventByStore,
        };
      } else {
        dados = {
          tipo_equipamento: this.cadastro.tipo_equipamento,
          status: this.cadastro.status,
          descricao: this.cadastro.descricao,
          is_app: this.cadastro.is_app,
          link_vendas: this.cadastro.link_vendas,
        };
      }

      this.$axios
        .put(
          this.ENDPOINTS.ALTERAR_EQUIPAMENTO + this.cadastro.idequipamento,
          dados
        )
        .then(response => {
          if (response) {
            this.limparFormularioEquipamento();
            router.push({
              name: "equipments",
            });
          }

          this.cadastro.loading = false;
        })
        .catch(() => {
          this.cadastro.loading = false;
        });
    },

    /**
     * @description Método para deletar equipamento
     * @param {String} idequipamento ID do equipamento
     */
    deletarEquipamento(idequipamento) {
      this.$axios
        .delete(this.ENDPOINTS.DELETAR_EQUIPAMENTO + idequipamento)
        .then(() => this.getEquipamentos())
        .catch(() => (this.loading = false));
    },

    // ---- // ---------------------------------------- FUNÇÕES AUXILIARES ---------------------------------------- // ---- //

    /**
     * @description Método para abrir o modal de confirmação de remoção de equipamento
     * @param {id} String - ID do equipamento
     * @param {msg} String - Mensagem de confirmação
     */
    remover(id, msg) {
      this.$config.modalConfirm = true;
      this.text = msg;
      this.cadastro.idequipamento = id;
    },

    /**
     * @description Método para desabilitar o equipamento
     */
    desabilitarEquipamento(idequipamento) {
      this.$axios
        .put(this.ENDPOINTS.DESABILITAR_EQUIPAMENTO + idequipamento)
        .then(response => {
          if (response) {
            this.getEquipamentos();
          }
        });
    },

    /**
     * @description Método para habilitar equipamento
     * @param {String} idusuario - ID do equipamento
     * @param {String} status - Status ativo
     * @return {Promise} Retorna uma promise com o resultado da requisição
     */
    habilitarEquipamento(idequipamento) {
      this.$axios
        .put(this.ENDPOINTS.ALTERAR_EQUIPAMENTO + idequipamento, {
          status: "ATIVO",
        })
        .then(response => {
          if (response) {
            this.getEquipamentos();
          }
        });
    },

    /**
     * @description Método de confirmação de remoção de equipamento
     */
    funcaoRemover() {
      this.loading = true;
      this.deletarEquipamento(this.cadastro.idequipamento);
    },

    /**
     * @description Método de gerar o link de vendas
     */
    generateLink(idponto_venda, idequipamento) {
      this.$axios
        .get(
          this.ENDPOINTS.GERAR_LINK_VENDAS +
            idponto_venda +
            "/" +
            idequipamento,
          {}
        )
        .then(response => {
          if (response) {
            this.cadastro.link_vendas = response;
          }
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Método para gerar o QRCode
     */
    generateQRCode() {
      let dados = {};
      dados = {
        link_vendas: this.cadastro.link_vendas,
      };
      if (dados.link_vendas == "") {
        this.$config.alert(
          "Não é possivel gerar o link de vendas, pois ele esta vazio!",
          this.$config.dados.errorColor
        );
        return;
      }
      this.$axios
        .postPDF(this.ENDPOINTS.GERAR_QRCODE, dados)
        .then(response => {
          var file = new Blob([response], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Função que filtra equipamentos
     */
    filtroEquipamentos() {
      this.filtros = [];
      if (this.filter.descricao != "") {
        this.filtros.push({
          campo: "equi.descricao",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.descricao,
        });
      }

      if (
        this.filter.tipo_equipamento != "" &&
        this.filter.tipo_equipamento != null
      ) {
        this.filtros.push({
          campo: "equi.tipo",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.tipo_equipamento,
        });
      }

      if (this.filter.status != "" && this.filter.status != null) {
        this.filtros.push({
          campo: "equi.status",
          tipo: "string",
          valor: this.filter.status,
        });
      }

      if (
        this.filter.serie_equipamento != "" &&
        this.filter.serie_equipamento != null
      ) {
        this.filtros.push({
          campo: "equi.numero_serie",
          tipo: "string",
          orientacao: "like",
          valor: this.filter.serie_equipamento,
        });
      }

      let filtered = this.filtros;
      this.loading = true;
      this.$axios
        .post(
          this.ENDPOINTS.LISTAR_EQUIPAMENTOS,
          JSON.stringify({ filtros: filtered })
        )
        .then(response => {
          this.equipamentos = response;
          this.loading = false;
        });
    },

    /**
     * @description Função que valida dados de cadastro e alteração de equipamentos
     */
    async validarCadastro() {
      if (
        this.cadastro.tipo_equipamento == "" ||
        this.cadastro.tipo_equipamento == null
      ) {
        this.$config.alert(
          "Selecione o tipo de equipamento!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.tipo_equipamento =
          "Selecione o tipo de equipamento!";
        return;
      }

      if (this.cadastro.tipo_equipamento == "POS") {
        if (this.cadastro.status === "" || this.cadastro.status === null) {
          this.$config.alert(
            "Selecione o status!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.status = "Selecione o status!";
          return;
        }

        if (
          this.cadastro.point_sale.idponto_venda == "" ||
          this.cadastro.point_sale.idponto_venda == null
        ) {
          this.$config.alert(
            "Selecione o ponto de venda!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.point_sale = "Selecione o ponto de venda!";
          return;
        }

        if (
          this.cadastro.descricao === "" ||
          this.cadastro.descricao === null
        ) {
          this.$config.alert(
            "Preencha corretamente a descrição!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.descricao = "Preencha corretamente a descrição!";
          return;
        }

        if (
          this.cadastro.rede_vendas === "" ||
          this.cadastro.rede_vendas === null
        ) {
          this.$config.alert(
            "Preencha corretamente o tipo de rede de vendas!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.rede_vendas =
            "Preencha corretamente o tipo de rede de vendas!";
          return;
        }

        if (
          this.cadastro.lojas.length === 0 ||
          this.cadastro.lojas === null ||
          this.cadastro.lojas === ""
        ) {
          this.$config.alert(
            "É necessário ao menos uma loja vinculada.",
            this.$config.dados.errorColor
          );
          this.cadastro.error.lojas =
            "É necessário ao menos uma loja vinculada.";
          return;
        }

        if (
          this.cadastro.numero_serie === "" ||
          this.cadastro.numero_serie === null
        ) {
          this.$config.alert(
            "Preencha corretamente o número de série!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.numero_serie =
            "Preencha corretamente o número de série!";
          return;
        }
        if (
          this.cadastro.data_ativacao === "" ||
          this.cadastro.data_ativacao === null
        ) {
          this.$config.alert(
            "Preencha corretamente a data de ativação!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.data_ativacao =
            "Preencha corretamente a data de ativação!";
          return;
        }
      } else {
        if (this.cadastro.status === "" || this.cadastro.status === null) {
          this.$config.alert(
            "Selecione o status!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.status = "Selecione o status!";
          return;
        }

        if (
          this.cadastro.descricao === "" ||
          this.cadastro.descricao === null
        ) {
          this.$config.alert(
            "Preencha corretamente a descrição!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.descricao = "Preencha corretamente a descrição!";
          return;
        }

        if (this.cadastro.is_app && this.cadastro.link_vendas == "") {
          this.$config.alert(
            "Preencha corretamente o link de vendas!",
            this.$config.dados.errorColor
          );
          this.cadastro.error.link_vendas =
            "Preencha corretamente o link de vendas!";
          return;
        }
      }

      if (this.equipamentosAddEdit == "editar") {
        this.alterarEquipamento();
      } else {
        this.cadastrarEquipamento();
      }
    },

    limparFormularioEquipamento() {
      /**
       * @description Limpa formulário de cadastro de equipamentos
       */
      this.cadastro.loading = false;
      this.cadastro.idpdv_empty = true;
      this.cadastro.equipamentosAddEdit = "new";
      this.cadastro.idequipamento = "";
      this.cadastro.tipo_equipamento = "";
      this.cadastro.status = "";
      this.cadastro.descricao = "";
      this.cadastro.data_ativacao = "";
      this.cadastro.numero_serie = "";
      this.cadastro.is_app = 0;
      this.cadastro.aplicar_taxa = 0;
      this.cadastro.link_vendas = "";
      this.cadastro.rede_vendas = "";
      this.cadastro.lojas = [];
      this.cadastro.events = [];
      this.cadastro.point_sale = {};

      /**
       * @description Limpa erros do cadastro de equipamentos
       */
      this.cadastro.error.tipo_equipamento = [];
      this.cadastro.error.status = [];
      this.cadastro.error.descricao = [];
      this.cadastro.error.data_ativacao = [];
      this.cadastro.error.numero_serie = [];
      this.cadastro.error.link_vendas = [];
      this.cadastro.error.rede_vendas = [];
      this.cadastro.error.lojas = [];
    },
  },
});
